import { legacy_createStore } from "redux";
import courseReducer from "./reducer";

export const store = legacy_createStore(courseReducer);
